import React from "react";

import "./RemovePopup.css";

import QuestionMarkBlackBg from '../Svg/QuestionMarkBlackBg'
import WithPopup from "../../../HOC/WithPopup/WithPopup";
import { isMobileView } from "../../../Utility/utility";

export default (props) => {

    const contentStyleDesktop = {
        position: "absolute",
        margin: "auto",
        top: "50%",
        transform: "translateY(-50%)",
        width: "100%"
    }

    const contentStyleMobile = {
        position: "absolute",
        margin: "auto",
        top: "0",
        width: "100%"
    }

    return (
            <WithPopup contentStyle={isMobileView() ? contentStyleMobile : contentStyleDesktop}>
                <div className="remove-popup-popup-container" automationid="SalesLead_Div_RemovePopupPopupContainer_0">
                    <div className="remove-popup-popup-title-wrapper" automationid="SalesLead_Div_RemovePopupPopupWrapper_0">
                        <button onClick={props.close} className="remove-popup-popup-close-button" automationid="SalesLead_Button_RemovePopupPopupClose_0">x</button>
                        <div>
                            <div className="remove-popup-popup-icon"><QuestionMarkBlackBg></QuestionMarkBlackBg></div>
                            <div className="remove-popup-popup-title" automationid={`SalesLead_Div_RemovePopupPopupHeading_0`}>Are you sure?</div>
                            <div className="remove-popup-popup-content" automationid={`SalesLead_Div_RemovePopupPopupDescription_0`}>{props.text}</div>
                        </div>
                    </div>
                    {
                        isMobileView() ?
                            <div className="remove-popup-popup-footer-btns">
                                <button onClick={props.onClick} className="remove-popup-popup-remove-button" automationid="SalesLead_Button_RemovePopupPopupRemove_0">Yes, remove</button>
                                <button onClick={props.close} className="remove-popup-popup-cancel-button" automationid="SalesLead_Button_RemovePopupPopupCancel_0">No, cancel</button>
                            </div>
                        :
                            <div className="remove-popup-popup-footer-btns">
                                <button onClick={props.close} className="remove-popup-popup-cancel-button" automationid="SalesLead_Button_RemovePopupPopupCancel_0">No, cancel</button>
                                <button onClick={props.onClick} className="remove-popup-popup-remove-button" automationid="SalesLead_Button_RemovePopupPopupRemove_0">Yes, remove</button>
                            </div>
                    }
                </div>
            </WithPopup>
        )
}